import gql from "graphql-tag";

export const updateI18n = gql`
    mutation AgendaCategoryI18n ($input: AgendaCategoryI18nInput!) {
    AgendaCategoryI18n (input: $input) {
        language_code
        name
    }
}`;
